import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

interface AskQuestionPayload {
  productId: string;
  body: { product: string; [key: string]: any };
  withFiles?: boolean;
}

const askQuestion = async (payload: AskQuestionPayload): Promise<any> => {
  try {
    const { data } = await apiService.post<any>(
      `/clarifications`,
      payload.body
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export const useAskQuestion = () => {
  const queryClient = useQueryClient();
  const id = useAuthStore((state) => state.user?.id);

  return useMutation({
    mutationFn: async (payload: AskQuestionPayload) => {
      return await askQuestion(payload);
    },
    onSuccess: async (_data, variables) => {
      if (!variables.withFiles) {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: ['product-updates', id, variables.productId]
          })
        ]);
      }
    }
  });
};
